import { find, pullAllBy, map } from 'lodash';

class DayFormController {
  constructor($rootScope, $scope, $state, dayService, messageService, markdownService, configService, integrationApiService, access) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.dayService = dayService;
    this.messageService = messageService;
    this.marked = markdownService;
    this.configService = configService;
    this.integrationApiService = integrationApiService;
    this.access = access;
  }

  $onInit() {
    this.creditAllowed = this.$rootScope.currentProperty.credit_spa_days;
    this.isAdmin = this.access.check('admin');

    if (this.day.track_quantity === undefined) this.day.track_quantity = this.$rootScope.currentProperty.track_quantity;
    this.day.description = this.day.description || '';
    this.day.selectedcategories = this.day.categories || [];
    this.day.treatmentstate = this.day.treatmentstate || !this.creditAllowed;
    this.day.days = this.day.days || [];
    this.day.status = this.day.status || false;
    this.day.secret = this.day.secret || false;
    this.day.special_status = this.day.special_status || '';
    this.day.property_id = this.day.property_id || this.$rootScope.currentProperty.id;
    this.day.start_time = (this.day.start_time)? moment(this.day.start_time, 'HH:mm:ss') : '';
    this.day.event_status_id = (this.day.event_status_id) ? this.day.event_status_id.toString() : '0';
    this.currentPropertyName = this.$rootScope.currentProperty.name;
    this.currencySymbol = this.$rootScope.currentProperty.currency_symbol;

    if (!this.creditAllowed){
      this.day.selectedtreatments = [];
    }else{
      this.day.selectedtreatments = (this.day.treatmentstate ? this.day.additional_treatments : this.day.exclusions);
    }

    this.hasIntegration = !!this.$rootScope.currentProperty.integration;
    if (this.hasIntegration) {
        this.integrationApiService.integrationPackageCollect(this.$rootScope.currentProperty.id).then(response => {
            this.importedPackages = response.map(spaday => {
                if (spaday.integration_location){
                  spaday.name = spaday.name + ' @ ' + spaday.integration_location_name;
                }
                return spaday;
            });
        });
    }
  }

  onSave() {
    if (!find(this.day.selectedcategories, { id: this.day.primary_category})){
      this.messageService.failure(`You must select at least 1 category and set a primary category to continue`);
      this.messageService.push();
      this.saving = undefined;
      return Promise.reject({});
    }

    this.messageService.reset();

    this.day.treatments = [];
    this.day.options = [];

    if (this.day.treatmentstate){
      this.day.additional_treatments = map(this.day.selectedtreatments, 'id');
      this.day.exclusions = [];
    }else{
      this.day.exclusions = map(this.day.selectedtreatments, 'id');
      this.day.additional_treatments = [];
    }

    this.day.categories = map(this.day.selectedcategories, 'id');

    if ( this.day.start_time ) {
      this.day.start_time = this.day.start_time.format('HH:mm');
    }

    if (this.day.days){
      this.day.days = map(this.day.days, 'day');
    }

    let tempCats = this.day.selectedcategories;
    let tempPrimaryCat = this.day.primary_category;

    delete this.day.selectedtreatments;
    delete this.day.selectedcategories;
    delete this.day.upgrades;
    delete this.day.extras;
    delete this.day.days;
    delete this.day.extras;
    delete this.day.options;
    delete this.day.related;
    delete this.day.times;
    delete this.day.treatments;
    delete this.day.upgrades;

    return this.dayService.save(this.day)
      .then(response => {
        if (this.day.id) {
          this.messageService.success(`The Spa Day <strong>${this.day.name}</strong> was successfully updated!`, [`app.admin.day-edit({ 'day' : ${this.day.id}})`, `Spa Day`]);
          this.$state.go('app.admin.days');
        }else{
          this.day.selectedcategories = tempCats;
          this.day.primary_category = tempPrimaryCat;
          this.messageService.success(`The Spa Day <strong>${this.day.name}</strong> was successfully created. Please edit the start times.`);
          this.$state.go('app.admin.day-edit', {day: response.id, tab: 'times'});
        }
      })
      .catch((error) => {
        error.data = error.data.original || error.data;
        this.form.$api.setErrors(error.data);

        this.day.selectedcategories = tempCats;
        this.day.primary_category = tempPrimaryCat;

        let sourceElement = Object.keys(error.data);
        let verb = 'created';
        if ( this.day.id ) {
          verb = 'updated';
        }
        if ( sourceElement.length > 0 ) {
          let errors = '';
          for ( let element of sourceElement ) {
            errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
          }
          this.messageService.failure(`The Spa Day <strong>${this.day.name}</strong> could not be successfully ${verb}: <ul>${errors}</ul>`);
        } else {
          this.messageService.failure(`The Spa Day <strong>${this.day.name}</strong> could not be successfully ${verb}: ${error.statusText}`);
        }
        this.messageService.push();
      });
  }

  clearTreatments() {
    this.day.selectedtreatments = [];
  }

  initialSlug(){
    if (!this.day.id && document.getElementsByClassName('inline')[0].className.includes('untouched')){
      this.day.slug = (this.day.name ? this.day.name.replace(/[^a-zA-Z\d\s]+/g, '').replace(/[ ]+/g, '-').replace(/--+/g, '-').toLowerCase() : '');
    }
  }
}

DayFormController.$inject = [ '$rootScope', '$scope', '$state', 'dayService', 'messageService', 'markdownService', 'configService', 'integrationApiService', 'access' ];

export default DayFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/controllers/day.form.controller.js